import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
  import { useStore } from 'vuex';
  import { User, Utils } from 'types';
  import AnnaLogoIcon from './Logo/Anna.vue';
  import AnnaLogoSmallIcon from './Logo/AnnaSmall.vue';
  import CoBrandColoredIcon from './Logo/CoBrandColored.vue';
  import CoBrandWhiteIcon from './Logo/CoBrandWhite.vue';
  import CoBrandSmallIcon from './Logo/CoBrandSmall.vue';
  import FPColoredIcon from './Logo/FPColored.vue';
  import FPWhiteIcon from './Logo/FPWhite.vue';
  import FPSmallIcon from './Logo/FPSmall.vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'LogoIcon',
  props: {
    isSmall: {
      type: Boolean,
      default: false,
    },
    isColored: {
      type: Boolean,
      default: false,
    },
  },
  setup(__props) {

const props = __props

  const store = useStore();
  

  const userCategory = computed<User.UserCategory.Category>(
    () => store.state.user.category,
  );
  const cobrand = computed<Utils.Cobrand.Params>(
    () => store.state.support.cobrand,
  );
  const Logo = computed(() => {
    if (cobrand.value === Utils.Cobrand.Params.Anna) {
      if (props.isSmall) {
        return AnnaLogoSmallIcon;
      }
      return AnnaLogoIcon;
    }

    if (
      [
        User.UserCategory.Category.Individual,
        User.UserCategory.Category.Personal,
      ].includes(userCategory.value) ||
      cobrand.value === Utils.Cobrand.Params.None
    ) {
      if (props.isSmall) {
        return FPSmallIcon;
      }

      if (props.isColored) {
        return FPColoredIcon;
      }

      return FPWhiteIcon;
    }

    if (props.isSmall) {
      return CoBrandSmallIcon;
    }

    if (props.isColored) {
      return CoBrandColoredIcon;
    }

    return CoBrandWhiteIcon;
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(Logo))))
}
}

})